import getApproveRejectStore from ".";

export const hasPendingPeerDescription = ({ index }: { index: number }) => {
  const userApprovalData = getApproveRejectStore().approvalData.get()[index];
  const pendingPeerDescription =
    userApprovalData.peerDescriptionStatus === "pending";
  return pendingPeerDescription;
};
